import { graphql, useStaticQuery } from 'gatsby'

const allContentfulNavMenu = () => {
  return useStaticQuery(graphql`
    {
      allContentfulNavMenu(
        filter: {
          location: {
            in: [
              "Footer"
              "French Footer"
              "German Footer"
              "Japanese Footer"
              "Portuguese Footer"
              "Korean Footer"
              "Spanish Footer"
              "Chinese Footer"
              "New Footer"
              "New French Footer"
              "New German Footer"
              "New Japanese Footer"
              "New Portuguese Footer"
              "New Korean Footer"
              "New Spanish Footer"
              "New Chinese Footer"
            ]
          }
        }
      ) {
        nodes {
          name
          location
          entryLocale
          node_locale
          topHatLinks {
            ... on Node {
              ...topicCTA
              ...iconLink
            }
          }
          socialMediaFooterOnly {
            ... on ContentfulMicrocopySet {
              key
              values {
                key
                value
              }
            }
          }
          legalFooterOnly {
            ...topicCTA
          }
          menuGroups {
            ... on ContentfulMenuGroup {
              newGroupName
              parentLink {
                __typename
                ...topicCTA
              }
              pages {
                __typename
                ...topicCTA
                ...iconLink
                ... on ContentfulMenuGroup {
                  newGroupName
                  parentLink {
                    ...topicCTA
                  }
                  pages {
                    __typename
                    ... on ContentfulMenuGroup {
                      id
                      name
                    }
                    ...topicCTA
                    ...iconLink
                  }
                }
              }
            }
          }
        }
      }
    }

    fragment topicCTA on ContentfulTopicCta {
      __typename
      id
      externalUrl
      text
      description
      internalLink {
        ... on Node {
          ... on ContentfulPageAboutRpa {
            __typename
            id
            name
            slug
          }
          ... on ContentfulPageBlogPost {
            __typename
            id
            name
            slug
            blogCategory {
              seoMetadata {
                pageCanonicalUrl
              }
            }
          }
          ... on ContentfulPageCompanyListing {
            __typename
            contentful_id
            id
            name
            slug
          }
          ... on ContentfulPageDownload {
            __typename
            contentful_id
            id
            name
            slug
          }
          ... on ContentfulPageFlex {
            __typename
            id
            name
            slug
          }
          ... on ContentfulPageLegal {
            __typename
            contentful_id
            id
            name
            slug
          }
          ... on ContentfulPageMainBlog {
            __typename
            id
            name
            slug
          }
          ... on ContentfulPageNewsroomArticle {
            __typename
            contentful_id
            id
            name
            slug
          }
          ... on ContentfulPagePartner {
            __typename
            contentful_id
            id
            name
            slug
          }
          ... on ContentfulPagePlaceholder {
            __typename
            contentful_id
            id
            name
            slug
          }
          ... on ContentfulPageProduct {
            __typename
            id
            name
            slug
          }
          ... on ContentfulPageResource {
            __typename
            contentful_id
            id
            name
            slug
          }
          ... on ContentfulPageResourceDemo {
            __typename
            id
            name
            slug
          }
          ... on ContentfulPageResourceListing {
            __typename
            contentful_id
            id
            name
            slug
          }
          ... on ContentfulPageSolutions {
            __typename
            id
            name
            slug
          }
          ... on ContentfulPageWhitePaper {
            __typename
            contentful_id
            id
            name
            slug
          }
          ... on ContentfulTopicAnchorLink {
            __typename
            contentful_id
            name
            identifier
          }
          ... on ContentfulWrapperPdf {
            __typename
            id
            name
            slug
          }
        }
      }
    }

    fragment iconLink on ContentfulTopicIconLink {
      __typename
      id
      name
      icon {
        altText
        image {
          file {
            url
          }
        }
      }
      ctaText
      url
      description
    }
  `)
}

export default { allContentfulNavMenu }
